import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { YleInteractiveEmbed } from "./yleEmbed";
const app = new YleInteractiveEmbed(
  "2023-04-teininhuone",
  "#teini-app"
);

app.isReady = () => {
  console.log(import.meta.env);
  console.log(app.parameters)
  const rootDom = ReactDOM.createRoot(app.container);
  rootDom.render(
    <React.StrictMode>
      <App container={app.container} parameters={app.parameters}/>
    </React.StrictMode>
  );
}